const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      className={`relative overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-ink" : "border-ink/10 bg-paper"}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee-x flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-serif text-2xl sm:text-3xl font-light tracking-wide px-8 ${dark ? "text-white/40" : "text-ink/35"}`}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-accent" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
